$(document).ready(function() {
    if ($('.radio').length > 0) {

        var radio_status = 0;
        var radio_track = 0;
        var radio_volume = 0;

        $('.radio').click(function (e) {
            var elm = $(this);
            var xPos = e.pageX - elm.offset().left;
            var yPos = e.pageY - elm.offset().top;

            var width = $('.radio').width();
            var height = $('.radio').height();

            var xPosRelative = 100 / width * xPos;
            var yPosRelative = 100 / height * yPos;

            console.log(xPosRelative);
            console.log(yPosRelative);

            var trackCount = $('.radio-track').length;

            function radioStop(radio) {
                radio[0].pause();
                radio_status = 0;
                radio_volume = 0;
                $('.radio .display').html('Off');
                $('.radio').removeClass('on');
                $('.radio').removeClass('bounce');

                $('.layer').removeClass('active');

            }

            // Powerbutton
            if (xPosRelative > 75 && yPosRelative > 74 && xPosRelative < 79 && yPosRelative < 86) {
                $('.radio').toggleClass('on');

                var radio = $("#radio-player");

                if (radio_status == 0) {
                    var currentTrack = $("#radio-track-1 source").attr('src');

                    radio.find('source').attr('src', currentTrack);
                    radio.get(0).load();
                }

                if (radio[0].paused) {
                    radio[0].volume = 0.5;
                    radio[0].play();

                    radio.on('ended', function () {
                        radioStop(radio);
                    });

                    radio_status = 1;
                    radio_track = 1;

                    if (bootstrapSize() == 'xs') {
                        $('.radio .display').html('On');
                    } else {
                        $('.radio .display').html('radio.ausblick');
                    }

                    // radio[0].on('ended',function(){
                    //     radio[0].pause();
                    //     radio_status=0;
                    //     $('.radio .display').html('Off');
                    // });

                } else {
                    radioStop(radio);
                    // radio[0].pause();
                    // radio_status=0;
                    // $('.radio .display').html('Off');

                }

            }

            // Sender
            if (xPosRelative > 69 && yPosRelative > 73 && xPosRelative < 73 && yPosRelative < 85) {

                if (radio_status == 1) {

                    old_track = radio_track;

                    radio_track++;
                    if (radio_track > trackCount) {
                        radio_track = 2;
                    }

                    $('.tuning.tuning-' + (radio_track - 1)).addClass('active');
                    $('.tuning.tuning-' + (old_track - 1)).removeClass('active');

                    if ($('.tuning.tuning-2').hasClass('active')) {
                        setTimeout(function () {
                            $('.radio').addClass('bounce');
                        }, 500);
                    } else {
                        $('.radio').removeClass('bounce');
                    }

                    var radio = $("#radio-player");
                    var nextTrack = $("#radio-track-" + radio_track + " source").attr('src');

                    radio.find('source').attr('src', nextTrack);
                    radio.get(0).load();

                    radio[0].play();

                    if (!isIE()) {
                        var start = (Math.random() * (400 - 10)) + 10;
                        radio[0].currentTime = start;
                    }

                    radio.on('ended', function () {
                        radio[0].currentTime = 0;
                        //radioStop(radio);
                    });

                    var title = $("#radio-track-" + radio_track).data('title');
                    $('.radio .display').html(title);
                }

            }

            // Volume
            if (xPosRelative > 63 && yPosRelative > 73 && xPosRelative < 67 && yPosRelative < 83) {
                if (radio_status == 1) {
                    var radio = $("#radio-player");
                    radio_volume++;
                    if (radio_volume > 3) radio_volume = 0;
                    $('.volume').removeClass('active');
                    $('.volume.volume-' + radio_volume).addClass('active');
                    if (radio_volume == 0) {
                        radio[0].volume = 0.5;
                    } else {
                        radio[0].volume = 0.5 + round(radio_volume / 10, 1);
                    }
                    $('.display-volume span').html((50 + (radio_volume * 10)));

                }

            }

        })

    }
});